/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateFragmentSocialUploadsMutationRequest, WebAppCreateFragmentSocialUploadsMutationResponse } from "../models/WebAppCreateFragmentSocialUploads";

export function getWebAppCreateFragmentSocialUploadsUrl() {
  const res = { method: 'POST', url: `/web-app/v1/fragment-social-uploads` as const }
  return res
}

/**
 * @summary Start upload of fragment or video-editor project media to platform
 * {@link /web-app/v1/fragment-social-uploads}
 */
export async function webAppCreateFragmentSocialUploads(data: WebAppCreateFragmentSocialUploadsMutationRequest, config: Partial<RequestConfig<WebAppCreateFragmentSocialUploadsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppCreateFragmentSocialUploadsMutationResponse, ResponseErrorConfig<Error>, WebAppCreateFragmentSocialUploadsMutationRequest>({ method : "POST", url : getWebAppCreateFragmentSocialUploadsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}